module.exports = __webpack_public_path__ + "img/tpc-printable-flyers-1.f93b37cd.jpg";